import PageLoaderLegacy from '@/app/common/components/__PageLoaderLegacy.tsx'
import { FamilyApplicationQueries } from '@/queries/family_applications/queries.ts'
import { RootState } from '@/storage/store.ts'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Chat } from './_components/Chat.tsx'

function ChatPage() {
  const { applicantId } = useParams<{ applicantId?: string }>()
  const { selectedProgramYear } = useSelector((s: RootState) => s.programs)

  const { status, data } = useQuery(
    FamilyApplicationQueries.getFamilyApplicationById(
      applicantId!,
      selectedProgramYear!.id,
      {
        refetchOnMount: true,
      }
    )
  )

  const { user } = useSelector((s: RootState) => s.auth)

  if (data?.flags.length === 0) {
    return (
      <div className="flex flex-col h-full max-h-screen justify-center items-center">
        <h1 className="text-2xl font-semibold text-gray-800">
          {user?.first_name} {user?.last_name} has no flags
        </h1>
      </div>
    )
  }

  return (
    <PageLoaderLegacy status={status}>
      <div className="flex flex-col h-full max-h-screen">
        {data && user?.id && <Chat userId={user.id} application={data} />}
      </div>
    </PageLoaderLegacy>
  )
}

export { ChatPage }
